export default {
  name: { defaultValue: '' },
  address: { defaultValue: '' },
  city: { defaultValue: '' },
  state: { defaultValue: '' },
  country: { defaultValue: '' },
  zip: { defaultValue: '' },
  is_active: { defaultValue: true }
}
